import { inject, Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { ToastrService } from 'src/app/shared/services/toastr/toastr-service';
import { ApiService } from 'src/app/shared/services/api/api.service';

import {
  createProfileDataEffects,
  createProfileDeleteEffects,
  ProfileDataActions,
} from './profile-data.feature';
import { LangService } from 'src/app/shared/services/lang/lang.service';
import { extractErrorMessage } from 'src/app/shared/util/extract-error-message';

@Injectable()
export class ProfileDataEffects {
  private action$ = inject(Actions);
  private store = inject(Store);
  private apiService = inject(ApiService);
  private toastrService = inject(ToastrService);
  private labels = inject(LangService).lang.features.profileData;

  private effects = createProfileDataEffects(this.action$, this.store, {
    load: () => this.apiService.getProfileList(),
    notifyError: () => this.labels.toasts.fetchingError,
  });

  fail$ = this.effects.fail$;
  load$ = this.effects.load$;
  ensure$ = this.effects.ensure$;

  private deleteEffects = createProfileDeleteEffects(this.action$, {
    deleteItem: profile =>
      this.apiService.deleteProfile(profile.profileName ?? ''),
    notifyError: (profile, error) =>
      this.toastrService.error(
        extractErrorMessage(error) ||
          this.labels.toasts.defaultDeletionError(profile),
      ),
    notifySuccess: profile =>
      this.toastrService.success(this.labels.toasts.deletionSuccess(profile)),
    onSuccess: deletedProfile =>
      this.store.dispatch(
        ProfileDataActions.transform({
          transformation: profiles =>
            profiles.filter(
              profile => profile.profileName !== deletedProfile.profileName,
            ),
        }),
      ),
  });

  delete$ = this.deleteEffects.delete$;
  deleteFail$ = this.deleteEffects.deleteFail$;
  deleteSuccess$ = this.deleteEffects.deleteSuccess$;
}
